/**
 * Created by jonas on 2020-08-13.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class DasUBootGameMode extends GameMode {
    //Add your custom modes here!

    public static readonly AVALANCHE:string = "AVALANCHE";
    public static readonly SUPER_FREESPIN:string = "SUPER_FREESPIN";
    /*    public static readonly FREESPIN_EAST:string = "FREESPIN_EAST";
        public static readonly FREESPIN_WEST:string = "FREESPIN_WEST";
        public static readonly FREESPIN_COAST_TO_COAST:string = "FREESPIN_COAST_TO_COAST";
        public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";


        //These are only used by the client, not the server. server only use RESPIN.
        public static readonly RESPIN_EAST:string = "RESPIN_EAST";
        public static readonly RESPIN_WEST:string = "RESPIN_WEST";*/

}